"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { buttonVariants } from "@/components/ui/button";
import { trackOptionalAddOnClicked } from "@/lib/analytics/segment";
import { cn } from "@/lib/utils";
import { useNewCartStore } from "@/stores/useNewCartStore";
import type { OptionalAddOn } from "./types";
interface Props {
  addOn: OptionalAddOn;
  position: number;
}
export function OptionalAddOnCard(t0) {
  const $ = _c(15);
  const {
    addOn,
    position
  } = t0;
  const setIsCartOpen = useNewCartStore(_temp);
  let t1;
  if ($[0] !== addOn.sku || $[1] !== position || $[2] !== setIsCartOpen) {
    t1 = () => {
      trackOptionalAddOnClicked({
        sku: addOn.sku,
        position
      });
      setIsCartOpen(false);
    };
    $[0] = addOn.sku;
    $[1] = position;
    $[2] = setIsCartOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  const t2 = `/${addOn.slug}`;
  let t3;
  if ($[4] !== addOn.imageAlt || $[5] !== addOn.imageSrc) {
    t3 = addOn.imageSrc && <div className="relative aspect-square w-full overflow-hidden rounded-md"><Image src={addOn.imageSrc} alt={addOn.imageAlt} fill={true} className="object-contain" sizes="(min-width: 640px) 25vw, 33vw" /></div>;
    $[4] = addOn.imageAlt;
    $[5] = addOn.imageSrc;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== addOn.title) {
    t4 = <p className="self-start text-sm text-card-foreground">{addOn.title}</p>;
    $[7] = addOn.title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={cn(buttonVariants({
      variant: "outline",
      size: "sm"
    }), "w-full self-end")}>Customize</span>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleClick || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t6 = <Link href={t2} onClick={handleClick} className="group grid grid-rows-subgrid row-span-3 gap-2 rounded-md no-underline! focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{t3}{t4}{t5}</Link>;
    $[10] = handleClick;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(state) {
  return state.setIsCartOpen;
}